import {shortDateFormat2} from "../../util/DateTimeUtil";
import React from "react";
import moment from "moment/moment";

type Props = {
  week: number,
  onWeekChange: (week: number) => void,
}

/**
 * Shows the week adjuster for choosing a week for classes and services in the booking flow
 * @constructor
 */
export const WeekAdjuster = (props: Props) => {

  return <div className={'ClassScheduleDateAdjuster'}>
    <button disabled={props.week <= 0} onClick={() => props.onWeekChange(Math.max(0, props.week - 1))}>
      <img className={'DarkModeInvert'} src={require('../../images/icons/chevron_left.png')}/>
    </button>

    <b>
      {shortDateFormat2(moment().add(props.week, 'weeks').valueOf())} -
      {shortDateFormat2(moment().add(props.week, 'weeks').add(6, 'days').valueOf())}
    </b>

    <button
        disabled={props.week >= 3}
        onClick={() => props.onWeekChange(Math.min(3, props.week + 1))}>
      <img className={'DarkModeInvert'} src={require('../../images/icons/chevron_right.png')}/>
    </button>
  </div>
  
}